<template>
  <div class="left-aside" :class="{'active':isCollapse}">
    <div class="head">
      <div class="logo">
        <img src="../../assets/images/logo.png">
      </div>
      <div class="header">
        <!--<img src="../../assets/images/headPortrait.png">-->
        <div v-if="!isCollapse">
          {{ $t('common.welcome') }},
          {{ userName }}
        </div>
        <div style="margin-top: 15px">
          <a href="javascript:void(0)" @click="logOut()" style="color:#ff0000"> {{ $t('message.logout') }} </a>
        </div>
      </div>
    </div>
    <div class="menu-list">
      <el-menu
        class="el-menu-vertical-demo"
        @open="handleOpen"
        @close="handleClose"
        :collapse="isCollapse"
        :hide-timeout="0"
        :default-active="defaultActiveIndex"
        @select="handleSelect"
      >
        <router-link v-for="(item,index) in menudataList" :to="{path:item.path}" :key="item.id">
          <el-menu-item :index="index.toString()">
            <i :class="item.icon" />
            <span slot="title">{{ item.menuName }}</span>
          </el-menu-item>
        </router-link>
        <!-- <el-menu-item>
          <i class="el-icon-chat-line-round" style="color: #333;" />
          <a :href="partnerCode" style="color: #333;font-weight: 500;" target="_blank"><span>Feedback</span></a>
        </el-menu-item> -->
        <a :href="partnerCode" target="_blank">
          <el-menu-item>
            <i class="el-icon-chat-line-round" /><span>Feedback</span>
          </el-menu-item>
        </a>
      </el-menu>
    </div>
    <div class="operate">
      <div class="btn">
        <span v-if="isCollapse" /><span v-else />
        <el-dropdown v-if="isCollapse===false" @command="handleLanguage">
          <span class="el-dropdown-link">
            Language<i class="el-icon-arrow-down el-icon--right" />
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="en">English</el-dropdown-item>
            <el-dropdown-item command="tr">Türkçe</el-dropdown-item>
            <el-dropdown-item command="vi">ViệtName</el-dropdown-item>
            <el-dropdown-item command="zh">中文</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div v-show="isCollapse===false" class="line" />
      <div class="btn" @click="idShow">
        <span v-if="isCollapse" />
        <span v-else>Hide</span>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import API from '../../API';
import eventBus from '../../libs/eventBus';
import { logOut } from '../../libs/loginUtils';

export default {
  name: 'Left',
  data () {
    return {
      isCollapse: false,
      menudataList: [],
      language: this.$i18n.locale,
      userName: '',
      defaultActiveIndex: '0',
      partnerCode: ''
    };
  },
  methods: {
    logOut,
    handleOpen (key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath);
    },
    handleSelect (key, keyPath) {
      this.defaultActiveIndex = key;
    },
    handleLanguage (command) {
      localStorage.setItem('lang', command);
      this.language = command;
      this.$i18n.locale = command;
      eventBus.$emit('reloadAll');
      this.$nextTick(function () {
        this.getLeftMenuData();
      });
    },
    idShow () {
      this.isCollapse = !this.isCollapse;
      this.resizeWidth();
    },
    resizeWidth () {
      this.$nextTick(function () {
        let divLeft = document.getElementsByClassName('el-aside')[0];
        if (this.isCollapse) {
          divLeft.style.width = 65 + 'px';
          eventBus.$emit('leftWidthChange', 65);
        } else {
          divLeft.style.width = 260 + 'px';
          eventBus.$emit('leftWidthChange', 260);
        }
      });
    },
    getLeftMenuData () {
      API.getLeftMenuData(this.language).then(res => {
        let json = res.data;
        if (json.status === '200') {
          this.menudataList = json.data;
          this.getActiveMenuIndex();
        }
      }).catch(e => {
      });
    },
    getActiveMenuIndex () {
      let path = this.$route.path;
      this.menudataList.forEach((menu, index) => {
        if (path === menu.path) {
          this.defaultActiveIndex = index.toString();
        }
      });
    },
    getCurUserInfo () {
      API.getCurUser().then(res => {
        let json = res.data;
        if (json.status === '200') {
          this.userName = json.data.userName;
          this.partnerCode = 'https://ruijie.feishu.cn/share/base/form/shrcnEPQMwBVtOGbjIfOSAiLoGS?prefill_Source=PRM&hide_Source=1&prefill_partnerCode=' + json.data.partnerCode + '&hide_partnerCode=1';
        }
      }).catch(e => {
        console.log(e);
      });
    }
  },
  mounted () {
    this.getLeftMenuData();
    this.getCurUserInfo();
  }
};
</script>

<style lang="scss">
  .left-aside {
    width: 100%;
    position: relative;
    text-align: left;
    height: 100%;
    transition: width 0.3s ease-in-out;
    background: #FFFFFF;

    &.active {
      width: 63px;

      .head {
        .logo {
          img {
            width: 90%;
            margin-top: 50px;
          }
        }

        .header {
          img {
            width: 80%;
            margin-top: 30px;
          }
        }
      }

      .operate {
        .btn {
          float: none;
        }

        .btn:nth-of-type(1) {
          background-position-x: 20px;
          background-size: 16px;
        }

        .btn:nth-of-type(3) {
          background: url("../../assets/images/unfold.png") center left no-repeat;
          background-position-x: 20px;
          background-size: 14px;
          padding-left: 40px;
        }
      }
    }

    .head {
      width: 100%;
      height: 150px;
      text-align: center;
      border-bottom: 1px solid #EBEEF5;

      .logo {
        img {
          width: 100px;
          margin-top: 30px;
        }
      }

      .header {
        img {
          width: 80px;
          margin-top: 20px;
        }

        div {
          margin-top: 20px;
        }
      }
    }

    .operate {
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      border-top: 1px solid #EBEEF5;

      .btn {
        float: left;
        width: 50%;
        height: 36px;
        padding-left: 34px;
        line-height: 36px;
        color: #999999;
      }

      .btn:nth-of-type(1) {
        // background: url("../../assets/images/loginOut.png") center left no-repeat;
        background-position-x: 12px;
        background-size: 16px;
      }

      .btn:nth-of-type(3) {
        background: url("../../assets/images/fold.png") center left no-repeat;
        background-position-x: 20px;
        background-size: 14px;
        padding-left: 40px;
      }

      .line {
        position: absolute;
        width: 1px;
        height: 24px;
        background: #EBEEF5;
        left: 50%;
        top: 50%;
        margin-top: -12px;
      }
    }
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>
